export const getAudienceCardStyle = (_, { palette = {} }) => ({
  cardContainer: {
    fontSize: 14,

    '& .audience-header': {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      marginBottom: 15,

      '& .audience-name': {
        flexGrow: 1,
        fontWeight: 600,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },

      '& .audience-highlight': {
        fontSize: 18,
      },
    },

    '& .audience-body': {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',

      '& > div': {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        flexFlow: 'wrap',
        flexWrap: 'wrap',
        fontSize: 14,
      },

      '& .audience-icon': {
        marginRight: 2,
      },

      '& .audience-demographics > span, .audience-customer-data > span': {
        marginLeft: 4,
        wordBreak: 'break-word',
      },

      '& .audience-interests': {
        fontSize: 13,
        gap: '4px',

        '& .audience-interest': {
          backgroundColor: palette.neutralLighter,
          borderRadius: 4,
          padding: '4px 8px',
          wordBreak: 'break-word',
        },
      },

      '& .audience-profiles': {
        fontSize: 13,
        gap: '4px',

        '& .audience-profile': {
          backgroundColor: palette.neutralLighter,
          borderRadius: 4,
          padding: '4px 8px',
          wordBreak: 'break-word',
        },
      },
    },
  },
});
